import { render } from "./SSpinner.vue?vue&type=template&id=327292d2&scoped=true"
import script from "./SSpinner.vue?vue&type=script&lang=js"
export * from "./SSpinner.vue?vue&type=script&lang=js"

import "./SSpinner.vue?vue&type=style&index=0&id=327292d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327292d2"]])

export default __exports__